import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=7b78ff74&"
import script from "./UploadImage.vue?vue&type=script&lang=ts&"
export * from "./UploadImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UploadImage.vue"
export default component.exports